<template>
    <div class="kefu_v">
        <iframe :src="customerServiceUrl" title="在线客服"></iframe>
    </div>
</template>

<script>
    export default {
        name: "Kefu",
        computed: {
            customerServiceUrl() {
                return `${process.env.BASE_URL}michat-kefu.html`;
            }
        },
        created() {
            this.$parent.footer('user', false);
        }
    };
</script>

<style lang="less" scoped>
    .kefu_v {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-overflow-scrolling: touch;

        iframe {
            display: block;
            width: 100%;
            height: 100%;
            border: 0;
        }
    }
</style>
